import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { EventMenuProfileService } from 'src/app/components/profile-menu/profile-menu.service';
import { ApiCore } from 'src/app/config/api';
import { AppRoutes } from 'src/app/config/routes';
import { ApiService } from 'src/app/core/http/api.service';
import { DeviceDetectorService } from 'src/app/shared/services/device-detector.service';

@Component({
  selector: 'app-modal-bonus',
  templateUrl: './modal-bonus.component.html',
  styleUrls: ['./modal-bonus.component.css'],
})
export class ModalBonusComponent implements OnInit {
  @Input() show: boolean = false;
  @Output() toggle = new EventEmitter<boolean>();
  public loadingBonos: boolean = false;
  public bonos: {
    creditsAmount: number;
    createdAt: string;
    id: string;
  }[] = [];
  // this.getBonuses();
  @Input() mobile: boolean = false;
  
  constructor(
    private readonly api: ApiService,
    private readonly deviceDetector: DeviceDetectorService,
    private readonly router: Router,
    private readonly eventMenuProfileService: EventMenuProfileService,
  ) {
    // this.deviceDetector.isMobile().subscribe((isMobile) => {
    //   this.isMobile = isMobile;
    // });
  }

  ngOnInit(): void {
    this.getBonuses();
  }

  private getBonuses() {
    this.api.list(ApiCore.OPERATOR + '/last-bonuses').subscribe({
      next: (res) => {
        console.log({ Bonuses: res });
        this.bonos = res.data;
        this.loadingBonos = false;
      },
      error: (err) => {
        console.error({ err });
      },
    });
  }
  redirectToTransactions(){
    this.eventMenuProfileService.showProfile();
    this.toggle.emit();
    this.router.navigate([AppRoutes.USER_PROFILE], {
      queryParams: {
        transactions: 'active',
      },
    });
  }  
}
